import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/edit_inspect/packing_house_process/${packing_house_id}/${packing_house_process_id}`
    );
  },
  fetchHarvestedBatch({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/edit_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
  fetchExportedBatches({ container_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/edit_inspect/container/${container_id}/exported_batches`
    );
  },
  fetchTemplate({ packing_house_id, packing_house_process_id,  harvested_batch_id, packing_process_quality_template_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/edit_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}`
    );
  },
  fetchExportQualityInspect({ packing_house_id, packing_house_process_id, packing_process_quality_template_id, quality_inspect_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/edit_inspect/quality_inspect/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}/${quality_inspect_id}`
    );
  },
  updateExportQualityInspect({
    quality_inspect_id,
    packing_house_id,
    packing_house_process_id,
    harvested_batch_id,
    packing_process_quality_template_id,
    started_at,
    finished_at,
    samplings,
    quality_samplings,
  }) {
    return RequesterV1.patch(
      `/packing_house/quality_control/process/edit_inspect/update/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}/${quality_inspect_id}`,
      {
        quality_inspect: {
          started_at,
          finished_at,
          samplings,
        },
        quality_samplings
      }
    );
  },
  updateWithoutSamplings({
    quality_inspect_id,
    packing_house_id,
    packing_house_process_id,
    harvested_batch_id,
    packing_process_quality_template_id,
    started_at,
    finished_at,
    quality_generals,
  }) {
    return RequesterV1.patch(
      `/packing_house/quality_control/process/edit_inspect/update_without_samplings/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}/${quality_inspect_id}`,
      {
        quality_inspect: {
          started_at,
          finished_at,
        },
        quality_generals
      }
    );
  },
};
